import React from 'react'
import { Route } from 'react-router'
import getPath from '../shared/utils/getPath'
import Container from './containers/Container'
import FormContainer from './containers/FormContainer'

const messageRoutes = (
  <Route
    component={Container}
    key="message-routes"
    path={getPath('backend', '/message')}
  >
    <Route
      component={FormContainer}
      key="message-routes"
      path={getPath('backend', '/message/create')}
    />
  </Route>
)

export default messageRoutes



// WEBPACK FOOTER //
// ./src/message/routes.js